import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AccountRoutingModule } from './account-routing.module'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { AccountReducers } from './account.root.state'
import { UserProfileComponent } from './user-profile/user-profile.component'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { NgrxFormsModule } from 'ngrx-forms'
import { AccountDashboardComponent } from './account-dashboard/account-dashboard.component'
import { UserAddressesComponent } from './user-addresses/user-addresses.component'
import { UserAccessDataComponent } from './user-profile/user-access-data/user-access-data.component'
import { UserPaymentMethodsComponent } from './user-payment-methods/user-payment-methods.component'
import { UserCloseAccountComponent } from './user-profile/user-close-account/user-close-account.component'
import { MatDialogModule } from '@angular/material/dialog'
import { ChangeEmailComponent } from './user-profile/change-email/change-email.component'
import { ConfirmationDialogComponent } from './user-profile/change-email/confirmation-dialog/confirmation-dialog.component'
import { TranslateLoader, TranslateModule, TranslatePipe} from '@ngx-translate/core'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { NavigationComponent } from './navigation/navigation.component'
import { MatTabsModule } from '@angular/material/tabs'
import { ChangePhoneNumberComponent } from './user-profile/change-phone-number/change-phone-number.component'
import { ForgotPasswordDialogComponent } from './user-profile/user-access-data/forgot-password-dialog/forgot-password-dialog.component'
import { ForgotPasswordEmailSentComponent } from './user-profile/user-access-data/forgot-password-dialog/forgot-password-email-sent/forgot-password-email-sent.component'
import { AddressCardComponent } from './user-addresses/address-card/address-card.component'
import { NewAddressComponent } from './user-addresses/new-address/new-address.component'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { EditAddressComponent } from './user-addresses/edit-address/edit-address.component'
import { DeleteAddressComponent } from './user-addresses/delete-address/delete-address.component'
import { NewPaymentMethodComponent } from './user-payment-methods/new-payment-method/new-payment-method.component'
import { DeletePaymentMethodComponent } from './user-payment-methods/delete-payment-method/delete-payment-method.component'
import { PaymentMethodCardComponent } from './user-payment-methods/payment-method-card/payment-method-card.component'
import { EditPaymentMethodComponent } from './user-payment-methods/edit-payment-method/edit-payment-method.component'
import { NewCreditCardComponent } from './user-payment-methods/new-payment-method/new-credit-card/new-credit-card.component'
import { NewPaypalComponent } from './user-payment-methods/new-payment-method/new-paypal/new-paypal.component'
import { NewDebitChargeComponent } from './user-payment-methods/new-payment-method/new-debit-charge/new-debit-charge.component'
import { CanDeactivateGuardService } from '../utils/services/can-deactivate-guard.service'
import { UserProfileEffects } from './user-profile/user-profile.effects'
// import { MatSelectCountryModule } from '@angular-material-extensions/select-country'
import { ChangeMobileComponent } from './user-profile/change-mobile/change-mobile.component'
import { ReplaceEmptyWithStringPipe } from '../replace-empty-with-string.pipe'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { DebitChargeCancelDialogComponent } from './user-payment-methods/payment-method-card/debit-charge-cancel-dialog/debit-charge-cancel-dialog.component'
import { ChangeBirthdayComponent } from './user-profile/change-birthday/change-birthday.component'
import { MatDatepickerModule } from '@angular/material/datepicker'
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDateFormats,
  MatNativeDateModule,
} from '@angular/material/core'
import { CustomDateAdapter } from './utils/CustomDateAdapter'
import { NewUserGuard } from '../uuidnot-found/new-user-guard.service'
import { MatTooltipModule } from '@angular/material/tooltip'
import { ManageSubscriptionEffects } from './manage-subscription/store/manage-subscriptions.effects'
import { FilterCustomFieldsPipe } from './manage-subscription/pipes/filter-custom-fields.pipe'
import { ManageSubscriptionComponent } from './manage-subscription/manage-subscription.component'
import { MatDividerModule } from '@angular/material/divider'
import { ConfirmModalComponent } from './manage-subscription/components/confirm-modal/confirm-modal.component'
import { browserLang, getSupportedLocale, HttpLoaderFactory } from '../language'
import { HttpClient } from '@angular/common/http'
import { SelectCountryComponent } from '../utils/components/select-country/select-country.component'

const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'numeric' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
}

@NgModule({
  declarations: [
    UserProfileComponent,
    AccountDashboardComponent,
    UserAddressesComponent,
    UserAccessDataComponent,
    UserPaymentMethodsComponent,
    UserCloseAccountComponent,
    ChangeEmailComponent,
    ConfirmationDialogComponent,
    NavigationComponent,
    ChangePhoneNumberComponent,
    ForgotPasswordDialogComponent,
    ForgotPasswordEmailSentComponent,
    AddressCardComponent,
    NewAddressComponent,
    EditAddressComponent,
    DeleteAddressComponent,
    NewPaymentMethodComponent,
    DeletePaymentMethodComponent,
    PaymentMethodCardComponent,
    EditPaymentMethodComponent,
    NewCreditCardComponent,
    NewPaypalComponent,
    NewDebitChargeComponent,
    ChangeMobileComponent,
    ReplaceEmptyWithStringPipe,
    DebitChargeCancelDialogComponent,
    ChangeBirthdayComponent,
    FilterCustomFieldsPipe,
    ManageSubscriptionComponent,
    ConfirmModalComponent,
  ],
  imports: [
    CommonModule,
    AccountRoutingModule,
    StoreModule.forFeature('account', AccountReducers),
    EffectsModule.forFeature([UserProfileEffects, ManageSubscriptionEffects]),
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    NgrxFormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild({
      defaultLanguage: getSupportedLocale(browserLang),
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MatCardModule,
    MatIconModule,
    MatTabsModule,
    MatButtonToggleModule,
    // MatSelectCountryModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatDividerModule,
    SelectCountryComponent,
    TranslatePipe,
  ],
  exports: [UserProfileComponent, ManageSubscriptionComponent, PaymentMethodCardComponent],
  providers: [
    CanDeactivateGuardService,
    NewUserGuard,
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
  ],
})
export class AccountModule {}
